import React from 'react';
import packageJson from '../package.json';
import { withRouter } from './actions/withRouterHook';
import { refreshCacheAndReload } from './actions/uiActions'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
global.appVersion = packageJson.version;

// version from response - first param, local version second param
const semverGreaterThan = (versionA, versionB) => {
    const versionsA = versionA.split(/\./g);
    const versionsB = versionB.split(/\./g);

    while (versionsA.length || versionsB.length) {
        const a = Number(versionsA.shift());

        const b = Number(versionsB.shift());
        // eslint-disable-next-line no-continue
        if (a === b) continue;
        // eslint-disable-next-line no-restricted-globals
        return a > b || isNaN(b);
    }
    return false;
};

class CacheBuster extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            isLatestVersion: false,
            checkForForceRefresh: this.checkForForceRefresh         
        };
    }

    handleRefreshCacheAndReload = () => {
        console.log("running handleRefreshCacheAndReload")
        this.props.refreshCacheAndReload();
    }

    checkForForceRefresh = () => {
        fetch('/version.json')
            .then((response) => response.json())
            .then((meta) => {
                const latestVersion = meta.version;
                const currentVersion = global.appVersion;
                console.log("latestVersion: " + latestVersion);
                console.log("currentVersion: " + currentVersion);
                const shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion);
                if (shouldForceRefresh) {
                    console.log(`We have a new version - ${latestVersion}. Should force refresh`);
                    this.handleRefreshCacheAndReload();
                } else {
                    console.log(`You already have the latest version - ${latestVersion}. No cache refresh needed.`);
                }
            });
    }

    componentDidMount() {
        console.log("CacheBuster loaded");
        //this.checkForForceRefresh();

        this.timer = setInterval(() => this.checkForForceRefresh(), 30000);
    }
    render() {
        const { loading, isLatestVersion, refreshCacheAndReload, checkForForceRefresh } = this.state;
        return this.props.children({ loading, isLatestVersion, refreshCacheAndReload, checkForForceRefresh });
    }
}

function mapStateToProps(state) {
    return {
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ refreshCacheAndReload }, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CacheBuster))